<template lang="">
  <div>
    <div class="main-header">
      <cardMode
        class="cardmode"
        :title="$t('main.index.annualInboundVolume')"
        :total="String(RKnumber)"
      >
        <a-tooltip :title="$t('main.index.tipToole')" slot="action">
          <a-icon type="info-circle-o" />
        </a-tooltip>
        <a-spin :spinning="loading">
          <div class="titlebody"></div>
        </a-spin>
        <template slot="footer">
          <span>{{
    $t('main.index.TGannualInboundVolume')
  }}</span>
</template>
</cardMode>

<cardMode
    class="cardmode"
    :title="$t('main.index.annualShipmentVolume')"
    :total="String(CHnumber)"
>
<a-tooltip :title="$t('main.index.tipToole')" slot="action">
  <a-icon type="info-circle-o"/>
</a-tooltip>
<a-spin :spinning="loading">
  <div class="titlebody"></div>
</a-spin>
<template slot="footer">
  <span>{{ $t('main.index.TGannualShipmentVolume') }}</span>
</template>
</cardMode>

<cardMode
    class="cardmode"
    :title="$t('main.index.annualDeliveryVolume')"
    :total="String(QSnumber)"
>
<a-tooltip :title="$t('main.index.tipToole')" slot="action">
  <a-icon type="info-circle-o"/>
</a-tooltip>
<a-spin :spinning="loading">
  <div class="titlebody"></div>
</a-spin>
<template slot="footer">
  <span>{{ $t('main.index.TGannualDeliveryVolume') }}</span>
</template>
</cardMode>

<!--金额相关-->
<!--订单总金额-->
<cardMode
    class="cardmode"
    :title="$t('main.index.totalAmount')"
    :total="String(totalAmount)"
>
<a-tooltip :title="$t('main.index.tipToole')" slot="action">
  <a-icon type="info-circle-o"/>
</a-tooltip>
<a-spin :spinning="loading">
  <div class="titlebody"></div>
</a-spin>
<template slot="footer">
  <span>{{ $t('main.index.TGannualTotalAmount') }}</span>
</template>
</cardMode>
<!--实付金额-->
<cardMode
    class="cardmode"
    :title="$t('main.index.totalPayAmount')"
    :total="String(totalPayAmount)"
>
<a-tooltip :title="$t('main.index.tipToole')" slot="action">
  <a-icon type="info-circle-o"/>
</a-tooltip>
<a-spin :spinning="loading">
  <div class="titlebody"></div>
</a-spin>
<template slot="footer">
  <span>{{ $t('main.index.TGannualTotalPayAmount') }}</span>
</template>
</cardMode>
<!--优惠金额-->
<cardMode
    class="cardmode"
    :title="$t('main.index.totalDiscountAmount')"
    :total="String(totalDiscountAmount)"
>
<a-tooltip :title="$t('main.index.tipToole')" slot="action">
  <a-icon type="info-circle-o"/>
</a-tooltip>
<a-spin :spinning="loading">
  <div class="titlebody"></div>
</a-spin>
<template slot="footer">
  <span>{{ $t('main.index.TGannualTotalDiscountAmount') }}</span>
</template>
</cardMode>
</div>

<a-card :bordered="false" :body-style="{padding: '0'}">
<a-spin :spinning="loading">
  <div class="salesCard">
    <a-tabs
        default-active-key="1"
        size="large"
        :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}"
    >
      <div class="extra-wrapper" slot="tabBarExtraContent">
        <div class="extra-item">
          <a @click="getOrderStatistics(1)">{{ $t('main.index.selectDay') }}</a>
          <a @click="getOrderStatistics(2)">{{ $t('main.index.selectWeek') }}</a>
          <a @click="getOrderStatistics(3)">{{ $t('main.index.selectMount') }}</a>
          <a @click="getOrderStatistics(4)">{{ $t('main.index.selectYear') }}</a>
        </div>

        <a-select
            show-search
            :placeholder="$t('main.index.searchSite')"
            :value="selectSearchValue"
            :style="{width: '256px'}"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            @search="handleSearch"
            @change="handleChange"
            :allowClear="true"
        >
          <a-select-option v-for="d in selectedItems" :key="d.id">
            {{ d.name }}
          </a-select-option>
        </a-select>
      </div>

      <a-tab-pane :tab="$t('main.index.orderStatus')" key="1">
        <a-row>
          <a-col :xl="17" :lg="12" :md="12" :sm="24" :xs="24">
            <Curved :curveData="orderStatisticsResult"/>
          </a-col>
          <a-col :xl="7" :lg="12" :md="12" :sm="24" :xs="24">
            <a-row :gutter="[16,50]" style="padding-right: 8px;">
              <a-col :span="12" @click="goDetail(0)">
                <a-statistic
                    :title="$t('main.index.storedTotal')"
                    :value="KBRKnumber"
                    class="demo-class"
                >
                  <template #suffix>
                    <span>{{ $t("main.index.suffix") }}</span>
                  </template>
                </a-statistic>
              </a-col>
              <a-col :span="12" @click="goDetail(1)">
                <a-statistic
                    :title="$t('main.index.storageTotal')"
                    :value="KBCHnumber"
                    class="demo-class"
                >
                  <template #suffix>
                    <span>{{ $t("main.index.suffix") }}</span>
                  </template>
                </a-statistic>
              </a-col>

              <a-col :span="12" @click="goDetail(2)">
                <a-statistic
                    :title="$t('main.index.receivedTotal')"
                    :value="KBQSnumber"
                    class="demo-class"
                >
                  <template #suffix>
                    <span>{{ $t("main.index.suffix") }}</span>
                  </template>
                </a-statistic>
              </a-col>

              <a-col :span="12" @click="goDetail(3)">
                <a-statistic
                    :title="$t('main.index.exception')"
                    :value="KBQMnumber"
                    class="demo-class"
                >
                  <template #suffix>
                    <span>{{ $t("main.index.suffix") }}</span>
                  </template>
                </a-statistic>
              </a-col>
              <!--              金额相关-->
              <a-col :span="12">
                <a-statistic
                    :title="$t('main.index.totalAmount')"
                    :value="KBQTotalAmount"
                    class="demo-class"
                >
                  <template #suffix>
                    <span>{{ $t("main.index.amountUnit") }}</span>
                  </template>
                </a-statistic>
              </a-col>
              <a-col :span="12">
                <a-statistic
                    :title="$t('main.index.totalPayAmount')"
                    :value="KBQTotalPayAmount"
                    class="demo-class"
                >
                  <template #suffix>
                    <span>{{ $t("main.index.amountUnit") }}</span>
                  </template>
                </a-statistic>
              </a-col>
              <a-col :span="12">
                <a-statistic
                    :title="$t('main.index.totalDiscountAmount')"
                    :value="KBQTotalDiscountAmount"
                    class="demo-class"
                >
                  <template #suffix>
                    <span>{{ $t("main.index.amountUnit") }}</span>
                  </template>
                </a-statistic>
              </a-col>
              <a-col :span="12">
                <a-statistic
                    :title="$t('main.index.expressDelivery')"
                    :value="KBQExpressDelivery"
                    class="demo-class"
                >
                  <template #suffix>
                    <span>{{ $t("main.index.suffix") }}</span>
                  </template>
                </a-statistic>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-tab-pane>
    </a-tabs>
  </div>
</a-spin>
</a-card>
</div>
</template>

<script>
import cardMode from "@/components/card/cardMode.vue";
import Curved from "@/components/chat/Curved.vue";
import {mapGetters} from 'vuex'
import {orderSummary, orderStatistics, statisticsOrderMoney} from '@/api/app'
import dayjs from 'dayjs'
// import moment from 'moment'

export default {
  name: "Index",
  components: {
    cardMode,
    Curved
  },
  data() {
    return {
      dateFiledOptions: 4,
      loading: true,
      selectedItems: [],
      selectedItemsAll: [],
      selectSearchValue: undefined,
      RKnumber: "0000",
      CHnumber: "0000",
      QSnumber: "0000",
      KBRKnumber: "0",
      KBCHnumber: "0",
      KBQSnumber: "0",
      KBQMnumber: "0",
      KBQExpressDelivery: "0",
      KBQTotalAmount: "0",
      KBQTotalPayAmount: "0",
      KBQTotalDiscountAmount: "0",
      totalAmount: "0.00",
      totalPayAmount: "0.00",
      totalDiscountAmount: "0.00",
      orderStatisticsResult: [],
      // startTime: moment().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
      // endTime: moment().endOf('year').format('YYYY-MM-DD HH:mm:ss')
    };
  },
  created() {
    this.getOrder()
    this.getOrderAmount()
  },
  mounted() {
    this.getOrderStatistics(4)
    this.selectedItemsAll = this.siteInfo()
    this.selectedItems = JSON.parse(JSON.stringify(this.selectedItemsAll))
  },
  methods: {
    // moment,
    ...mapGetters(["siteInfo"]),
    // handleDateChange(dates) {
    //   if (dates && dates.length === 2) {
    //     const startDate = dates[0].format('YYYY-MM-DD HH:mm:ss');
    //     const endDate = dates[1].format('YYYY-MM-DD HH:mm:ss');
    //
    //     console.log('开始时间:', startDate);
    //     console.log('结束时间:', endDate);
    //     this.startTime = startDate
    //     this.endTime = endDate
    //     // 计算天数差
    //     const daysDiff = moment(endDate).diff(moment(startDate), 'days') + 1; // +1 包含开始当天
    //     console.log('daysDiff===', daysDiff);
    //     if (daysDiff > 31){
    //       this.dateFiled = 2
    //     } else if (daysDiff >90) {
    //       this.dateFiled = 4
    //     }
    //     // 调用API获取数据
    //     this.getOrderStatistics();
    //   }
    // },
    getOrderStatistics(dateFiled) {
      if (dateFiled) {
        this.dateFiledOptions = dateFiled
      }
      orderStatistics({
        dateFiled: this.dateFiledOptions,
        siteId: this.selectSearchValue,
        // startTime: this.startTime,
        // endTime: this.endTime
      }).then(res => {
        this.loading = false
        this.KBRKnumber = 0
        this.KBCHnumber = 0
        this.KBQSnumber = 0
        this.KBQExpressDelivery = 0
        this.KBQMnumber = 0
        this.KBQTotalAmount = 0
        this.KBQTotalPayAmount = 0
        this.KBQTotalDiscountAmount = 0

        if (res.code == "200") {
          const summaryData = res.data ? res.data.overview : {}
          if (!summaryData) {
            return;
          }
          this.KBRKnumber = summaryData.pending
          this.KBCHnumber = summaryData.inbound
          this.KBQSnumber = summaryData.delivered
          this.KBQMnumber = summaryData.exception
          this.KBQExpressDelivery = summaryData.expressDelivery

          const orderAmountOverviewData = res.data ? res.data.orderAmountOverview : {}
          if (orderAmountOverviewData) {
            this.KBQTotalAmount = orderAmountOverviewData.totalAmount
            this.KBQTotalPayAmount = orderAmountOverviewData.totalPayAmount
            this.KBQTotalDiscountAmount = orderAmountOverviewData.totalDiscountAmount
          }
          const orderStatisticData = res.data ? res.data.chart : []
          this.orderStatisticsResult = this.transformData(orderStatisticData)
        }
      })
    },

    transformData(data) {
      let result = [];
      let keys = Object.keys(data);
      let allTwoDigitStrings = keys.every(key => typeof key === 'string' && key.length === 2);

      if (!allTwoDigitStrings) {
        keys = keys.sort(); // Sort non-two-digit string keys
      } else {
        keys = keys.map(Number).sort((a, b) => a - b); // Sort two-digit string keys numerically
      }

      for (let key of keys) {
        let formattedKey = key.toString().padStart(2, '0');
        for (let city in data[formattedKey]) {
          result.push({
            month: formattedKey,
            city: city,
            temperature: data[formattedKey][city]
          });
        }
      }
      return result;
    },

    getOrder() {
      orderSummary().then(res => {
        if (res.code == "200") {
          const summaryData = res.data
          this.RKnumber = summaryData.all
          this.CHnumber = summaryData.delivered
          this.QSnumber = summaryData.inbound
        }
      })
    },
    getOrderAmount() {
      statisticsOrderMoney({}).then(res => {
        if (res.code == "200") {
          this.totalAmount = res.data.totalAmount
          this.totalPayAmount = res.data.totalPayAmount
          this.totalDiscountAmount = res.data.totalDiscountAmount
        }
      })
    },

    handleSearch(value) {
      this.selectedItems = this.selectedItemsAll.filter(item => item.name.indexOf(value) >= 0)
    },

    handleChange(value) {
      if (!value) {
        this.selectedItems = JSON.parse(JSON.stringify(this.selectedItemsAll))
      }
      this.selectSearchValue = value
      this.getOrderStatistics()
    },

    formatNumber(number) {
      let returnNumber = {
        startTime: null,
        endTime: dayjs().format("YYYY-MM-DD HH:mm:ss")
      }

      switch (number) {
        case 1:
          returnNumber.startTime = dayjs()
              .set('hour', 0)
              .set('minute', 0)
              .set('second', 0)
              .format("YYYY-MM-DD HH:mm:ss")
          break;
        case 2:
          returnNumber.startTime = dayjs()
              .subtract((dayjs().day() == 0 && 7) - 1, 'day')
              .set('hour', 0)
              .set('minute', 0)
              .set('second', 0)
              .format("YYYY-MM-DD HH:mm:ss")
          break;
        case 3:
          returnNumber.startTime = dayjs()
              .date(1)
              .set('hour', 0)
              .set('minute', 0)
              .set('second', 0)
              .format("YYYY-MM-DD HH:mm:ss")
          break;
        case 4:
          returnNumber.startTime = dayjs()
              .month(0)
              .date(1)
              .set('hour', 0)
              .set('minute', 0)
              .set('second', 0)
              .format("YYYY-MM-DD HH:mm:ss")
      }

      return returnNumber
    },

    goDetail(detail) {
      let time = this.formatNumber(this.dateFiledOptions)
      this.$router.push({
        name: `dashboard_order`,
        params: {
          siteId: this.selectSearchValue,
          orderStatus: detail + "",
          startTime: time.startTime,
          endTime: time.endTime
        }
      })
    }
  }
};
</script>

<style lang="less">
.main-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 30px;
}

.chart-node {
  width: 100%;
  height: 100%;
}

.demo-class {
  cursor: pointer;
}

.titlebody {
  border-radius: 30px 2px 30px 2px;
  background: cornflowerblue;
  height: 11px;
  width: 30px;
}

.cardmode {
  flex: 1;
}

.extra-wrapper {
  line-height: 55px;
  padding-right: 24px;

  .extra-item {
    display: inline-block;
    margin-right: 24px;

    a {
      margin-left: 24px;
    }
  }
}
</style>
